<template>
  <div class="productType">
    <el-form class="form" label-width="auto">
      <el-form-item>
        <el-text style="margin-right: 20px; font-size: larger; font-weight: bolder;">
          <template v-if="!data.productType.id">
            {{ util.language('新增', 'New ') }}
          </template>
          <template v-else>
            {{ util.language('编辑', 'Edit ') }}
          </template>
          {{ util.language('商品分类', 'Product Type') }}
        </el-text>
        <el-button-group>
          <el-button @click="router.go(-1)">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="save()" :loading="loading.save">{{ util.language('保存', 'Save') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="ID" v-if="data.productType.id">
        <el-input v-model="data.productType.id" disabled />
      </el-form-item>
      <el-form-item :label="util.language('英文名', 'English Name')">
        <el-input v-model="data.productType.enName" />
      </el-form-item>
      <el-form-item :label="util.language('中文名', 'Chinese Name')">
        <el-input v-model="data.productType.cnName" />
      </el-form-item>
      <el-form-item :label="util.language('排序', 'Sort')">
        <el-input-number style="width: 100%;" :controls="false" :precision="0" v-model="data.productType.orderBy" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { reactive, } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'

const router = useRouter()
const show = reactive({
  roles: []
})
const loading = reactive({
  save: false
})
const pageParam = cache.getObject(cache.keys.pageParam + "productType")
const data = reactive({
  productType: pageParam ? JSON.parse(JSON.stringify(pageParam)) : {}
})
if (!data.productType.orderBy) {
  data.productType.orderBy = 0
}

const save = () => {
  loading.save = true
  if (!data.productType.id) {
    api.post('/backend/product/addProductType', {
      enName: data.productType.enName,
      cnName: data.productType.cnName,
      orderBy: data.productType.orderBy,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  } else {
    api.post('/backend/product/setProductType', {
      id: data.productType.id,
      enName: data.productType.enName,
      cnName: data.productType.cnName,
      orderBy: data.productType.orderBy,
    }).then(() => {
      ElMessage.success(util.language('保存成功', 'success'))
      router.go(-1)
    }).finally(() => {
      loading.save = false
    })
  }
}
</script>

<style lang="less">
.productType {
  margin: auto;
  max-width: 900px;
}
</style>